import { Button, Drawer, Form, Input, Select, Space } from "antd";
import { useEffect } from "react";
import { keycloak } from "../../../..";
import { useAppSelector } from "../../../../app/store";
import SelectDropdownLgIcon from "../../../../assets/icons/SelectDropdownLgIcon";
// import EmployeeFileUpload from "../../../../components/Employees/EmployeeFileUpload";
import Loader from "../../../../components/ui/Loader";
import {
  useAddExpenseUnitMutation,
  useGetExpenseUnitDetailsQuery,
  useUpdateExpenseUnitMutation,
} from "../../../../features/org-setting/expenseUnit/expenseUnitApi";
import { useGetAllCompanyQuery } from "../../../../features/portal/companyOnboard/companyOnboardApi";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";
import { ModalComponentProps } from "../../../../types";
import { selectSearchOption } from "../../../../utils/utils";
import EmployeeFileUpload from "../../Employee/_components/EmployeeFileUpload";

export default function ManageExpenseUnit({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps<string>) {
  const [form] = Form.useForm();
  const { user, role } = useAppSelector((state) => state.auth);
  const isAdmin2 = keycloak?.realmAccess?.roles?.includes("admin2");
  const {
    isLoading: isExpenseUnitLoading,
    isError: isExpenseUnitDetailsError,
    error: expenseUnitDetailsError,
    data: expenseUnitDetails,
  } = useGetExpenseUnitDetailsQuery(data || "", {
    skip: !data && type !== "UPDATE",
  });
  // const {
  //   isError: isDepartmentError,
  //   error: departmentError,
  //   data: departmentData,
  // } = useGetDepartmentsQuery({ params: { skip: 0, limit: 0 } });
  const {
    isError: isAllCompanyError,
    error: allCompanyError,
    data: allCompanyData,
    isLoading: isAllCompanyLoading,
  } = useGetAllCompanyQuery({
    params: {
      company_id: role === "SUPER_ADMIN" ? undefined : user?.data?.company_id,
      page: 1,
      limit: 1000000000000,
    },
  });
  const [addExpenseUnit, { isLoading, isError, isSuccess, error }] =
    useAddExpenseUnitMutation();
  const [
    updateExpenseUnit,
    {
      isLoading: isUpdateLoading,
      isError: isUpdateError,
      isSuccess: isUpdateSuccess,
      error: updateError,
    },
  ] = useUpdateExpenseUnitMutation();
  // error toast message
  useError(isError, error, "Business unit added fail");
  useError(isUpdateError, updateError, "Business unit updated fail");
  useError(
    isExpenseUnitDetailsError,
    expenseUnitDetailsError,
    "Get business unit fail"
  );
  // useError(
  //   isDepartmentError,
  //   departmentError,
  //   "Get head of business data fail"
  // );

  const onFinish = (values: unknown) => {
    if (type === "UPDATE" && data) {
      return updateExpenseUnit({ body: values, id: data });
    }

    return addExpenseUnit(values);
  };

  useEffect(() => {
    if (Object.keys(expenseUnitDetails?.data || {}) && type === "UPDATE") {
      const expenseUnit = expenseUnitDetails?.data;

      form.setFieldsValue({
        name: expenseUnit?.name,
        business_id: expenseUnit?.business_id,
        // abbreviation: expenseUnit?.abbreviation,
        logo: expenseUnit?.logo,
      });
    }
  }, [form, expenseUnitDetails?.data, type]);

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Business unit added successfully");
      return handleClose();
    }
    if (isUpdateSuccess) {
      toast("success", "Business unit updated successfully");
      return handleClose();
    }
  }, [handleClose, isSuccess, isUpdateSuccess]);

  return (
    <Drawer
      title={`${
        type === "UPDATE" ? "Edit" : type === "ADD" ? "Add" : "View"
      } Business Unit`}
      placement="right"
      width={480}
      className="right_site_drawer"
      onClose={handleClose}
      {...rest}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
        initialValues={{
          business_id:
            role === "SUPER_ADMIN"
              ? allCompanyData?.data?.companies?.[0]?.id
              : user?.data?.company_id,
        }}
      >
        {isExpenseUnitLoading ? (
          <Loader />
        ) : (
          <>
            <Form.Item
              name="name"
              label="Business Unit Title"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter title",
                },
              ]}
            >
              <Input size="large" placeholder="Enter business unit title" />
            </Form.Item>
            <Form.Item
              name="business_id"
              label="Head of Business"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please select head of business",
                },
              ]}
            >
              <Select
                placeholder="Select head of business"
                size="large"
                allowClear
                showSearch
                filterOption={selectSearchOption}
                // options={selectArrayOption(
                //   departmentData?.data?.departments || [],
                //   "name",
                //   "id"
                // )}
                options={
                  allCompanyData?.data?.companies?.map((company: any) => ({
                    label: company?.company_name,
                    value: company?.id,
                  })) || []
                }
                suffixIcon={<SelectDropdownLgIcon />}
                disabled={isAdmin2}
                optionFilterProp="label"
                loading={isAllCompanyLoading}
              />
            </Form.Item>
            <Form.Item
              name="logo"
              label="Business Logo"
              className="mb-4"
              valuePropName="fileUrl"
            >
              <EmployeeFileUpload
                form={form}
                accept=".png, .jpg, .jpeg, .gif"
                name="logo"
                fileSize={1}
                onChange={(url) =>
                  form.setFieldsValue({
                    logo: url,
                  })
                }
              />
            </Form.Item>
          </>
        )}

        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
            disabled={isLoading || isUpdateLoading}
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading || isUpdateLoading}
            disabled={isExpenseUnitLoading}
          >
            {type === "UPDATE" ? "Update" : "Create"}
          </Button>
        </Space>
      </Form>
    </Drawer>
  );
}
